import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect, ReactReduxContext, Provider } from 'react-redux';
import { createNewPartnerAffiliate, editPartnerAffiliate, setFormValue, validateForm } from 'redux/modules/newAffiliate';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import NewAffiliate from '../NewAffiliate/NewAffiliate';
import { EmptyState, Spinner } from 'components';
import * as styles from './NewAffiliate.scss';
var NewAffiliateWrap = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    valid: state.newAffiliate.validation.valid,
    firstPass: state.newAffiliate.validation.firstPass,
    hasCommissionsAccount: state.billing.hasCommissionsAccount,
    submittingNewClient: state.newAffiliate.submittingNewClient,
    orgDetails: state.newAffiliate.orgDetails,
    orgConfig: state.newAffiliate.orgConfig,
    affiliateProductId: state.newAffiliate.affiliateConfig.affiliateProductId
  };
}, {
  createNewPartnerAffiliate: createNewPartnerAffiliate,
  editPartnerAffiliate: editPartnerAffiliate,
  setFormValue: setFormValue,
  validateForm: validateForm
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewAffiliateWrap, _Component);

  var _super = _createSuper(NewAffiliateWrap);

  function NewAffiliateWrap(props) {
    var _this;

    _classCallCheck(this, NewAffiliateWrap);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleStep2NextClick", function () {
      if (!_this.state.creationInProgress) {
        _this.setState({
          creationInProgress: true
        });
      } // time to show any error messages on form


      if (_this.props.firstPass) {
        _this.props.setFormValue('firstPass', 'validation', false);
      }

      _this.props.validateForm();

      if (_this.props.valid) {
        _this.setState({
          newAffiliateFormStep: _this.state.newAffiliateFormStep + 1
        });
      }
    });

    _this.state = {
      newAffiliateFormStep: 1,
      creatingNewClient: false,
      creationInProgress: false
    };
    return _this;
  }

  _createClass(NewAffiliateWrap, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setFormValue('valid', 'validation', true);
      this.props.setFormValue('firstPass', 'validation', true);
    }
    /** *******************************************************************************************
     EVENT HANDLERS
    ********************************************************************************************/

  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var contractInfo = this.props.contractInfo; // CANCEL BUTTON

      var newAffiliateDialogActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this2.setState({
            newAffiliateFormStep: 1
          });

          _this2.props.onClose();
        },
        style: {
          marginRight: 24
        }
      })]; // BACK BUTTON

      if (this.state.newAffiliateFormStep > 1) {
        newAffiliateDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          label: "Back",
          onClick: function onClick() {
            _this2.setState({
              newAffiliateFormStep: _this2.state.newAffiliateFormStep - 1
            });
          },
          style: {
            marginRight: 24
          }
        }));
      }

      if (this.state.newAffiliateFormStep === 1) {
        newAffiliateDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          disabled: !this.props.valid && !this.props.firstPass,
          secondary: true,
          label: "Next",
          onClick: this.handleStep2NextClick
        }));
      } else {
        newAffiliateDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: this.state.creatingNewClient,
          label: this.state.creatingNewClient ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spinner fa-spin",
            style: {
              fontSize: 20
            }
          }) : 'Finish',
          onClick: function onClick() {
            _this2.setState({
              creatingNewClient: true
            });

            if (_this2.props.edit) {
              _this2.props.editPartnerAffiliate(contractInfo.Organizations[0].id, _this2.props.orgDetails, _this2.props.affiliateProductId, _this2.props.orgConfig).then(function (res) {
                _this2.setState({
                  creatingNewClient: false,
                  newAffiliateFormStep: 1
                });

                _this2.props.onClose(); // updated much of state, but it relies on bits everywhere, better to reload and be sure


                window.location.reload();
              })["catch"](function (e) {
                _this2.setState({
                  creatingNewClient: false
                });
              });
            } else {
              _this2.props.createNewPartnerAffiliate(_this2.props.theme.org, _this2.props.orgDetails, _this2.props.affiliateProductId, _this2.props.orgConfig).then(function (res) {
                _this2.setState({
                  creatingNewClient: false,
                  newAffiliateFormStep: 1
                });

                _this2.props.onClose();

                browserHistory.push("/global/clients/".concat(res.data.org.id));
              })["catch"](function (e) {
                _this2.setState({
                  creatingNewClient: false
                });
              });
            }
          }
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          contentStyle: {
            maxWidth: 990,
            width: '97%'
          },
          title: "Add A New Client",
          autoScrollBodyContent: true,
          actions: newAffiliateDialogActions,
          modal: true,
          open: _this2.props.open
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(NewAffiliate, {
          contractInfo: contractInfo,
          formStep: _this2.state.newAffiliateFormStep
        })));
      }));
    }
  }]);

  return NewAffiliateWrap;
}(Component)) || _class);
export { NewAffiliateWrap as default };